module.exports = __webpack_public_path__ + "img/IDN.4d7e28a9.svg";